<template>
  <div class="page-wrapper">
    <div class="page-header">
      <WidgetToolbar :back="true" title="Accounts" :icon="require('@/assets/icon/accounts-active.svg')"
        @onBack="$navigationGoBack('/accounts')">
        <div class="options">
          <widgetSearch class="search-account" placeholder="Type in to Search..." icon="right" @keyup="searchContacts">
          </widgetSearch>

          <div class="h-spacer"></div>

          <widgetDropdown v-model="display_input_filter" :right="true" :hover="false" :interactive="true">
            <button class="btn-dropdown">
              Display
              <img class="icon" src="@/assets/icon/carret-bottom-gray.svg" />
            </button>
            <div slot="dropdown" class="dropdown-widget right">
              <a class="dropdown-item" href="#" v-for="(item, index) in display_filter" :key="index"
                @click="view_type = item.value" :class="{ active: view_type === item.value }">
                {{ item.name }}</a>
            </div>
          </widgetDropdown>
          <div class="v-line-divider" style="height: 40px"></div>

          <widgetDropdown v-model="tags_input_filter" :right="true" :hover="false" :interactive="true">
            <button class="btn-dropdown">
              Tags
              <img class="icon" src="@/assets/icon/carret-bottom-gray.svg" />
            </button>
            <div slot="dropdown" class="dropdown-widget right">
              <widgetListSelecter v-model="tags_filter" @close="tags_input_filter = false" @confirm="(data) => {
                tags_input_filter = false;
                filterByTag(data);
              }
                "></widgetListSelecter>
            </div>
          </widgetDropdown>

          <div class="v-line-divider" style="height: 40px"></div>

          <widgetDropdown v-model="sort_input_filter" :right="true" :hover="false" :interactive="true">
            <button class="btn-dropdown">
              Sort
              <img class="icon" src="@/assets/icon/carret-bottom-gray.svg" />
            </button>
            <div slot="dropdown" class="dropdown-widget right">
              <a class="dropdown-item" href="#" v-for="(item, index) in sort_filter" :key="index"
                @click="sort_filter_data = item.value" :class="{ active: sort_filter_data === item.value }">
                {{ item.name }}</a>
            </div>
          </widgetDropdown>
          <div class="v-line-divider" style="height: 40px"></div>

          <widgetButton style="width: 120px" @click="addNew()" :loading="false" class="btn-primary">
            Add Contact +
          </widgetButton>
        </div>
      </WidgetToolbar>
    </div>
    <div class="page-tab">
      <div class="page-path-widget">
        <img @click="$router.push({ path: '/accounts' })" src="@/assets/icon/accounts-active.svg" class="icon" />
        <label @click="$router.push({ path: '/accounts' })" class="path-name link">Accounts</label>
        <img src="@/assets/icon/outline-carret-green.svg" class="allow" />
        <label class="path-name" v-if="account"> {{ account.name }} </label>
      </div>

      <div class="page-tab-options row">
        <widgetButton v-if="show_selected_options" :loading="false" @click="addInternship()" class="btn-primary">
          Generate LIA
        </widgetButton>
        <widgetButton :loading="false" @click="getStartData()" class="btn-transparent fit-content">
          <img src="@/assets/icon/reflesh-gray.svg" width="15" />
        </widgetButton>
        <div v-if="show_selected_options" class="h-spacer"></div>
        <widgetDropdown v-if="show_selected_options" v-model="selected_list_dropdown" :right="true" :hover="false"
          :interactive="true" class="selected-dropdown">
          <button class="btn-dropdown">
            <img class="icon" style="height: 20px" src="@/assets/icon/menu-dot.svg" />
          </button>
          <div slot="dropdown" class="dropdown-widget right">
            <a class="dropdown-item" href="#" @click="sendEmailSelectedAccount()">Send Email</a>
            <a class="dropdown-item" href="#" @click="ExportSelectedContact()">Export Contact</a>
            <a class="dropdown-item" href="#" @click="DeleteSelectedContacts()">Delete Selected</a>
          </div>
        </widgetDropdown>
      </div>
    </div>
    <div class="page-body">
      <accountSidebar switch_tab="lia-generation" :account="account"></accountSidebar>
      <div v-if="account && account.contacts.length > 0" class="page-body-container">
        <div class="contacts-table" :class="{ 'with-details': contact_details }" v-if="view_type == 'list'">
          <table class="table-data">
            <thead class="table-header">
              <tr>
                <th>
                  <div class="space-between">
                    <div class="row">
                      <input v-model="selectAllChecked" @change="onSelectAll" class="checkbox" type="checkbox" />
                      <div class="h-spacer"></div>
                      <div>Name</div>
                    </div>
                  </div>
                </th>
                <th class="phone-hide">Email</th>
                <th class="phone-hide">Phone</th>
                <th>Position & Domain</th>
                <th>Contact Owner</th>
                <th>Tags</th>
                <th>Opting</th>
                <th>
                  <div class="center">Action</div>
                </th>
              </tr>
            </thead>
            <tbody class="table-body">
              <template v-for="(item, index) in account.lia_generation_contacts">
                <tr :key="index" class="table-row" :class="{ opted_out: item.optedOut }">
                  <td @click="viewContact(item)" class="opt_blur" :class="{ active: item.active }">
                    <div class="row">
                      <input v-model="item.checked" @change="checkItem(item)" class="checkbox" type="checkbox" />
                      <div class="h-spacer"></div>
                      <widgetProfile :title="item.first_name + ' ' + item.last_name"
                        :subtitle="processLocation(item.location)" file_name="" path="">
                      </widgetProfile>
                    </div>
                  </td>
                  <td class="phone-hide">
                    {{ item.email | validate }}
                  </td>
                  <td class="phone-hide">
                    {{ item.phone_alt | validate }}
                  </td>
                  <td class="phone-hide">
                    <div class="email">
                      {{ item.position | validate }}
                    </div>
                    <div class="phone">
                      {{ item.domain | validate }}
                    </div>
                  </td>
                  <td class="phone-hide">
                    <div class="email" v-if="item.owner">
                      {{ item.owner.first_name | validate }} {{ item.owner.last_name | validate }}
                    </div>
                  </td>
                  <td>
                    <widgetTagsViewer :tags="item.tags" @remove="(e) => {
                      removeContactTags(item.id, e.id, e.i, item.tags);
                    }"></widgetTagsViewer>
                  </td>

                  <td>
                    <div class="opted-out opt_blur" v-if="item.optedOut">
                      Opt-out
                    </div>
                  </td>
                  <td>
                    <div class="menu">
                      <dropdownMenu>
                        <ul>
                          <li v-if="item.optedOut">
                            <a @click="optContact(item, 'in')">Set as Opt-in</a>
                          </li>
                          <li v-else>
                            <a @click="optContact(item, 'out')">Set as Opt-out</a>
                          </li>
                          <li>
                            <a @click="updateContact(item)">Edit</a>
                          </li>
                          <li>
                            <app-dialog title="Delete Contact" ask="Are you sure you want to delete this contact?"
                              yesText="Delete" noText="Cancel" @onComfirm="deleteContact(item.id)">
                              <a>Delete Contact</a>
                            </app-dialog>
                          </li>
                        </ul>
                      </dropdownMenu>
                    </div>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
        <div class="contacts-items" :class="{ 'with-details': contact_details }" v-else>
          <div class="contact-item" v-for="(item, index) in account.contacts" :key="index"
            :class="{ opted_out: item.optedOut }">
            <div class="row" style="width: 100%; margin-bottom: 10px;">
              <input v-model="item.checked" @change="checkItem(item)" class="checkbox" type="checkbox" />
            </div>
            <img
              :src="item.profile_picture ? $fullUrl('images/profiles/' + item.profile_picture) : require('@/assets/contact-avatar.svg')" />
            <h3>{{ (item.first_name + " " + item.last_name) | validate }}</h3>
            <h5>{{ item.title | validate }}</h5>
            <div class="contact-details-info">
              <div class="email">{{ item.email | validate }}</div>
              <div class="phone">{{ item.phone_alt | validate }}</div>
              <div v-if="item.position" class="phone">{{ item.position }}</div>
              <div v-if="item.domain" class="phone">{{ item.domain }}</div>
            </div>
            <div class="tags" v-if="item.tags && item.tags.length">
              <div class="tag" v-for="(tag, tagIndex) in item.tags.slice(0, 3)" :key="tagIndex">
                {{ tag.name }}
              </div>
              <div class="tag" v-if="item.tags.length > 3">
                +{{ item.tags.length - 3 }}
              </div>
            </div>
            <dropdown-menu class="menu">
              <ul>
                <li v-if="item.optedOut">
                  <a @click="optContact(item, 'in')">Set as Opt-in</a>
                </li>
                <li v-else>
                  <a @click="optContact(item, 'out')">Set as Opt-out</a>
                </li>
                <li>
                  <a @click="viewContact(item)">View Details</a>
                </li>
                <li>
                  <a @click="updateContact(item)">Edit Contact</a>
                </li>
                <li>
                  <app-dialog title="Delete Contact" ask="Are you sure you want to delete this contact?"
                    yesText="Delete" noText="Cancel" @onComfirm="deleteContact(item.id)">
                    <a>Delete Contact</a>
                  </app-dialog>
                </li>
              </ul>
            </dropdown-menu>
          </div>
        </div>
        <div class="contact-details" :class="{ 'active': contact_details }" v-if="contact_details">
          <div class="contact-card">
            <img src="@/assets/contact-avatar.svg" />
            <h3>
              {{ contact_details.first_name | validate }} {{ " " }}
              {{ contact_details.last_name | validate }}
            </h3>
            <h5>{{ contact_details.title | validate }}</h5>
            <p>{{ contact_details.email | validate }}</p>
            <p>{{ contact_details.phone_alt | validate }}</p>
            <div class="tags">
              <div class="tag" v-for="(item, index) in contact_details.tags" :key="index">
                {{ item.name | validate }}
              </div>
            </div>
            <p class="comment">{{ contact_details.comment | validate }}</p>

            <dropdown-menu class="menu">
              <ul>
                <li>
                  <a @click="updateContact(contact_details)">Edit</a>
                </li>
                <li>
                  <app-dialog title="Delete Contact" ask="Are you sure you want to delete this contact?"
                    yesText="Delete" noText="Cancel" @onComfirm="deleteContact(contact_details.id)">
                    <a>Delete Contact</a>
                  </app-dialog>
                </li>
              </ul>
            </dropdown-menu>
          </div>

          <div v-if="contact_details && contact_details.tasks && contact_details.tasks.length > 0"
            class="widget-container">
            <div class="container-header">
              <h3>Tasks</h3>
              <button class="btn-view-all" @click="$router.push({ name: 'task' })">
                View All
              </button>
            </div>
            <div class="widget-body">
              <div v-for="(task, i) in contact_details.tasks.slice(0, 5)" :key="i" class="card">
                <div class="card-header">
                  <div class="title">
                    {{ task.name | validate }}
                  </div>
                  <div class="card-type">
                    <label :style="{ color: getColor(task.type) }">{{
                      task.type | validate
                    }}</label>
                    <div :style="{ 'background-color': getColor(task.type) }" class="type-box"></div>
                  </div>
                </div>
                <div class="compang-widget">
                  <span class="company-name" v-if="task.account">{{
                    task.account.name | validate
                  }}</span>
                </div>
                <div class="members">
                  <div class="member" v-for="(member, index) in task.assignees" :key="index">
                    <assingProfileToolTip :member="member">
                      <img v-if="member.profile_picture" :src="$fullUrl('images/profiles/' + member.profile_picture)
                        " :class="{ override: index > 0 }" />
                      <img v-else :class="{ override: index > 0 }" src="@/assets/avatar.png" />
                    </assingProfileToolTip>
                    <span v-if="task.assignees.length == 1" class="name">{{
                      (member.first_name + " " + member.last_name) | validate
                    }}</span>
                  </div>
                </div>
                <div class="due-date" v-if="task.due_date">
                  {{
                    moment(task.due_date).format("ddd, DD MMM YYYY") | validate
                  }}
                </div>
              </div>
            </div>
          </div>
          <div v-if="contact_details && contact_details.leads && contact_details.leads.length > 0"
            class="widget-container">
            <div class="container-header">
              <h3>Leads</h3>
              <button class="btn-view-all" @click="$router.push({ name: 'leads' })">
                View All
              </button>
            </div>
            <div class="widget-body">
              <div v-for="(lead, i) in contact_details.leads.slice(0, 5)" :key="i" class="lead-card">
                <div class="card-header"></div>
                <div class="title-widget">
                  <span class="lead-name">{{ lead.name | validate }}</span>
                </div>
                <div class="compang-widget" v-if="lead.account">
                  <span class="company-name">
                    {{ lead.account.name | validate }}
                  </span>
                </div>

                <div class="members">
                  <div class="member" v-for="(member, index) in lead.assignees" :key="index">
                    <assingProfileToolTip :member="member">
                      <img v-if="member.profile_picture" :src="$fullUrl('images/profiles/' + member.profile_picture)
                        " :class="{ override: index > 0 }" />
                      <img v-else :class="{ override: index > 0 }" src="@/assets/avatar.png" />
                    </assingProfileToolTip>
                    <span v-if="lead.assignees.length == 1" class="name">{{
                      (member.first_name + " " + member.last_name) | validate
                    }}</span>
                  </div>
                </div>
                <div class="price">{{ lead.value | validate }} USD</div>
              </div>
            </div>
          </div>
          <div class="footer">
            <button class="btn-cancel" @click="contact_details = null">
              Close
            </button>
          </div>
        </div>
      </div>
      <div v-else class="page-body-container not-found-widget">
        <widgetNotFoundWidget title="Contacts not found"
          content="You can create a new contact by clicking on the button below." btntext="Create Contact"
          @click="addNew()">
          <img class="widget-img" src="@/assets/admin-icon/student-search-icon.svg" />
        </widgetNotFoundWidget>
      </div>
    </div>

    <!-- Add - Update Modal -->
    <addUpdateContactModal v-if="show_form_add_update" :initWithAccount="account" :content="selected_contact"
      acccountType="company_contact" @success="contactSaved()" @close="show_form_add_update = false">
    </addUpdateContactModal>

    <!-- Send Mail -->
    <sendMailModal v-if="show_send_mail_modal" :content="selected_contacts" type="contact"
      @success="show_send_mail_modal = false" @close="show_send_mail_modal = false">
    </sendMailModal>

    <!-- Add LIA Modal -->
    <addInternshipModal v-if="show_add_internship_modal" :content="null" type="gen"
      :account_data="accounts_for_internship" @success="show_add_internship_modal = false"
      @close="show_add_internship_modal = false"></addInternshipModal>
  </div>
</template>
<script>
import { eventBus } from "@/main";
import accountSidebar from "@/views/Accounts/components/account_sidebar.vue";
import addUpdateContactModal from "@/views/Accounts/components/add_update_contact_modal.vue";
import sendMailModal from "@/views/Accounts/components/send_mail_modal.vue";
import addInternshipModal from "@/views/internship/components/add_internship_modal.vue";

export default {
  components: {
    accountSidebar,
    addUpdateContactModal,
    sendMailModal,
    addInternshipModal,
  },
  data: () => ({
    selected_contact: null,
    sort_input_filter: false,
    tags_input_filter: false,
    display_input_filter: false,
    roles_input_filter: false,
    view_type: "list",
    sort_filter_data: "",
    display_filter: [
      {
        value: "list",
        name: "List",
      },
      {
        value: "grid",
        name: "Grid",
      },
    ],
    tags_filter: [],
    roles_filter: [],
    sort_filter: [
      {
        value: "create_date",
        name: "Create Date",
      },
      {
        value: "name",
        name: "Name",
      },
    ],
    task_types: [
      {
        name: "Task",
        color: "#0884AF",
      },
      {
        name: "Follow up",
        color: "#1BA5A4",
      },
      {
        name: "Call",
        color: "#FFC273",
      },
      {
        name: "Mail",
        color: "#9FD076",
      },
      {
        name: "Meeting",
        color: "#ACAF5C",
      },
      {
        name: "Other",
        color: "#ED6400",
      },
    ],
    show_form_add_update: false,
    show_view_contant_modal: false,
    adding_contact_loading: false,
    contacts_data: [],
    contact_details: null,
    account: null,
    filter_form: {
      query: "",
      location: null
    },
    selected_list_dropdown: false,
    selectAllChecked: false,
    isAllContactSelected: false,
    show_selected_options: false,
    selected_contacts: [],
    show_send_mail_modal: false,
    show_add_internship_modal: false,
    accounts_for_internship: null,
  }),
  mounted() {
    let vm = this;
    vm.getStartData();
    vm.getContactsTags();
  },
  methods: {
    getColor(val) {
      let vm = this;
      let color = "";
      vm.task_types.forEach((item) => {
        if (item.name == val) {
          color = item.color;
        }
      });
      return color;
    },
    getContactsTags() {
      let vm = this;
      vm.$store
        .dispatch("CONTACTS_GET_TAGS")
        .then((response) => {
          vm.tags_filter = response.data.map((item) => {
            return {
              value: item.name,
              name: item.name,
            };
          });
        })
        .catch((error) => { });
    },
    filterBySort(val) {
      let vm = this;
      vm.$store
        .dispatch("CONTACTS_FILTER_BY_SORT", {
          option: val,
        })
        .then((response) => {
          vm.account.contacts = response.data;
        })
        .catch((error) => { });
    },
    filterByTag(val) {
      let vm = this;
      vm.$store
        .dispatch("CONTACTS_FILTER_BY_TAG", {
          option: val,
        })
        .then((response) => {
          vm.account.contacts = response.data;
        })
        .catch((error) => { });
    },
    searchContacts({ target }) {
      let vm = this;
      vm.$store
        .dispatch("CONTACTS_SEARCH", {
          query: target.value,
        })
        .then((response) => {
          vm.account.contacts = response.data;
        })
        .catch((error) => { });
    },
    deleteContact(id) {
      let vm = this;
      vm.$store
        .dispatch("ACCOUNT_CONTACT_DELETE", { contact_id: id })
        .then((response) => {
          vm.getStartData();
        })
        .catch((error) => {
          console.error({ error });
        });
    },
    viewContact(item) {
      let vm = this;
      vm.contact_details = item;
    },
    getStartData() {
      let vm = this;
      vm.$store.dispatch("LOADER_START");
      vm.$store
        .dispatch("ACCOUNT_SINGLE_GET_ALL_DATA", {
          account_id: vm.$route.params.id,
        })
        .then((responce) => {
          vm.$store.dispatch("LOADER_CLOSE");
          vm.account = responce.data;

          // if (window.innerWidth > 500) {
          //   if (vm.account.contacts.length > 0) {
          //     vm.viewContact(vm.account.contacts[0]);
          //   }
          // }
        })
        .catch((error) => {
          vm.$store.dispatch("LOADER_CLOSE");
        });
    },
    contactSaved() {
      let vm = this;
      vm.selected_contact = null;
      vm.show_form_add_update = false;
      vm.getStartData();
    },
    addNew() {
      let vm = this;
      let obj = {};
      eventBus.$set(obj, "account", vm.account);
      vm.selected_contact = obj;
      vm.show_form_add_update = true;
    },
    updateContact(item) {
      let vm = this;
      eventBus.$set(item, "account", vm.account);
      vm.selected_contact = item;
      vm.show_form_add_update = true;
    },
    processLocation(location) {
      if (!location) return "";
      return location.city ? location.city + (location.country ? ", " + location.country : "") : location.country || "";
    },
    onSelectAll({ target }) {
      this.isAllContactSelected = target.checked;
      if (target.checked) {
        this.account.contacts = this.account.contacts.map((item) => {
          this.$set(item, "checked", true);
          return item;
        });
      } else {
        this.account.contacts = this.account.contacts.map((item) => {
          this.$set(item, "checked", false);
          return item;
        });
      }
      this.validateChecked();
    },
    checkItem(item) {
      this.validateChecked();
    },
    validateChecked(type = "validate") {
      let vm = this;
      if (type == "validate") {
        vm.show_selected_options =
          vm.account.contacts
            .map((item) => item.checked)
            .filter((item) => item == true).length > 0;
        return;
      }
      return vm.account.contacts
        .filter((item) => item.checked == true)
        .map((item) => item);
    },
    removeContactTags(contactId, tagId, index, tags) {
      let vm = this;
      vm.$store
        .dispatch("CONTACT_DELETE_TAG", {
          id: tagId,
          contact_id: contactId,
        })
        .then((response) => {
          tags.splice(index, 1);
          vm.$notify({
            group: "status",
            title: "Message",
            text: "Tag removed",
            type: "success",
            duration: 3000,
          });
        })
        .catch((error) => {
          vm.$notify({
            group: "status",
            title: "Message",
            text: "Something went wrong",
            type: "warn",
            duration: 3000,
          });
          console.error({ error });
        });
    },
    optContact(item, status) {
      let vm = this;
      vm.$store
        .dispatch("ACCOUNT_CONTACT_OPTING", {
          contact_id: item.id,
          status: status,
        })
        .then((response) => {
          vm.$notify({
            group: "status",
            title: "Message",
            text: status == "out" ? "Contact was opted out" : "Contact opted in successfully",
            type: "success",
            duration: 3000,
          });
          if (status == "out") {
            vm.$set(item, "optedOut", true);
          } else {
            vm.$set(item, "optedOut", false);
          }
          vm.getStartData();
        })
        .catch((error) => {
          vm.$notify({
            group: "status",
            title: "Message",
            text: "Something went wrong",
            type: "warn",
            duration: 3000,
          });
          console.error({ error });
        });
    },
    filterByRole(roles) {
      this.$store
        .dispatch("CONTACTS_FILTER_BY_ROLE", {
          option: roles,
        })
        .then((response) => {
          this.account.contacts = response.data;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    onFilterByLocation(location) {
      this.filter_form.location = location;
      this.$store
        .dispatch("CONTACTS_FILTER_BY_LOCATION", {
          location: location,
        })
        .then((response) => {
          this.account.contacts = response.data;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    sendEmailSelectedAccount() {
      let vm = this;
      vm.selected_contacts = vm.validateChecked("data");
      if (vm.selected_contacts.length == 1) {
        if (vm.selected_contacts[0].optedOut) {
          vm.$notify({
            group: "status",
            title: "Message",
            text: "Selected contact opted out",
            type: "warn",
            duration: 3000,
          });
          return;
        }
      }
      vm.show_send_mail_modal = true;
    },
    ExportSelectedContact() {
      let vm = this;
      let ids = vm.validateChecked("data");
      vm.$store
        .dispatch("ACCOUNT_CONTACT_EXPORT", {
          ids: ids.map((item) => item.id),
          all: vm.isAllContactSelected,
          filters: vm.filter_form,
        })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "contact.xlsx");
          document.body.appendChild(link);
          link.click();
        })
        .catch((error) => {
          vm.$notify({
            group: "status",
            title: "Message",
            text: "Something went wrong",
            type: "warn",
            duration: 3000,
          });
          console.error({ error });
        });
    },
    DeleteSelectedContacts() {
      let vm = this;
      let ids = vm.validateChecked("data");
      vm.$store
        .dispatch("ACCOUNT_CONTACT_DELETE_SELECTED", {
          ids: ids.map((item) => item.id),
          all: vm.isAllContactSelected,
          filters: vm.filter_form,
        })
        .then((response) => {
          vm.$notify({
            group: "status",
            title: "Message",
            text: "Contact deleted successfully",
            type: "success",
            duration: 3000,
          });
          vm.getStartData();
        })
        .catch((error) => {
          vm.$notify({
            group: "status",
            title: "Message",
            text: "Something went wrong",
            type: "warn",
            duration: 3000,
          });
          console.error({ error });
        });
    },
    addInternship() {
      let vm = this;
      eventBus.$emit("openDialogMessage", {
        title: "Generate LIA",
        message: "We'd like to let you know that not all contacts can create LIAs. Just the LIA contacts are able to create LIA. As a result, the total number of internships may differ from the total number of contacts on your list.",
        action_label: "Proceed",
        callback: () => {
          let payload = {
            type: "many",
            origin: "contact",
            contacts: vm.validateChecked("data"),
            allSelected: vm.isAllContactSelected
          };
          vm.accounts_for_internship = payload;
          vm.show_add_internship_modal = true;
        },
        action_close_label: "Cancel",
      });
    },
  },
  watch: {
    sort_filter_data(val) {
      let vm = this;
      vm.filterBySort(val);
    },
  },
};
</script>

<style lang="scss" scoped>
.page-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #ebebeb;
  padding: 5px;

  .page-header {
    height: 38px;
    width: 100%;
    display: flex;
    align-items: center;

    .options {
      display: flex;
      align-items: center;

      .search-account {
        width: 250px;
      }

      .btn-add {
        margin-left: 20px;
        width: 130px;
      }
    }
  }

  .page-tab {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 35px;

    .page-path-widget {
      display: flex;
      align-items: center;

      .icon {
        width: 15px;
        margin-top: -3px;
        margin-right: 10px;
        cursor: pointer;
      }

      .allow {
        margin: 0px 10px;
      }

      .path-name {
        color: #1ba5a4;
        font-size: 12px;

        &.link {
          cursor: pointer;
        }
      }
    }
  }

  .page-body {
    height: calc(100% - 73px);
    display: flex;

    .page-body-container {
      height: 100%;
      width: calc(100% - 135px);
      display: flex;
      position: relative;

      &.not-found-widget {
        background: #fff;
        border-radius: 5px;

        .widget-img {
          width: 120px !important;
        }
      }

      .contacts-table {
        padding: 10px;
        background: #fff;
        border-radius: 5px;
        height: 100%;
        width: 100%;
        overflow-y: auto;
        position: relative;
        transition: width 0.3s ease;

        &.with-details {
          width: calc(100% - 410px);
        }
      }

      .contacts-items {
        padding: 10px;
        background: #fff;
        border-radius: 5px;
        height: 100%;
        width: 100%;
        overflow-y: auto;
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
        grid-gap: 15px;
        align-items: start;
        align-content: flex-start;
        grid-auto-rows: min-content;
        transition: width 0.3s ease;

        &.with-details {
          width: calc(100% - 410px);
        }

        .contact-item {
          position: relative;
          background: #f5f5f5;
          border-radius: 8px;
          display: flex;
          flex-direction: column;
          align-items: center;
          padding: 20px 15px;
          min-height: 320px;
          height: auto;
          transition: all 0.2s ease;

          &:hover {
            transform: translateY(-2px);
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
          }

          img {
            width: 80px;
            height: 80px;
            object-fit: cover;
            border-radius: 50%;
            margin-bottom: 15px;
          }

          h3 {
            margin: 0;
            font-size: 16px;
            font-weight: 600;
            text-align: center;
            margin-bottom: 5px;
          }

          h5 {
            margin: 0;
            font-size: 14px;
            color: #666;
            text-align: center;
            margin-bottom: 10px;
          }

          .contact-details-info {
            width: 100%;
            text-align: center;

            .email {
              font-size: 13px;
              color: #0884AF;
              margin-bottom: 5px;
              word-break: break-word;
            }

            .phone {
              font-size: 13px;
              color: #666;
            }
          }

          .tags {
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            gap: 5px;
            margin-top: 10px;
            padding: 0 10px;

            .tag {
              background: #e0e0e0;
              color: #666;
              padding: 4px 8px;
              border-radius: 4px;
              font-size: 11px;
            }
          }

          .menu {
            position: absolute;
            top: 10px;
            right: 10px;
          }

          &.opted_out {
            opacity: 0.7;
            background: #f8f8f8;

            &::after {
              content: 'Opted Out';
              position: absolute;
              top: 10px;
              left: 10px;
              background: #ff000021;
              color: #ff0000;
              padding: 2px 8px;
              border-radius: 3px;
              font-size: 11px;
            }
          }
        }

        @media (max-width: 1200px) {
          grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
        }

        @media (max-width: 768px) {
          width: 100%;
          grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
        }
      }

      .contact-details {
        position: absolute;
        right: -410px;
        top: 0;
        padding-right: 10px;
        width: 400px;
        height: 100%;
        overflow-y: auto;
        padding-bottom: 100px;
        background: #fff;
        border-radius: 5px;
        transition: right 0.3s ease;

        &.active {
          right: 0;
        }

        .contact-card {
          position: relative;
          display: flex;
          flex-direction: column;
          align-items: center;
          padding: 15px 25px;
          margin-bottom: 10px;

          img {
            width: 80px;
            margin-bottom: 19px;
          }

          h3 {
            margin: 0px;
            font-size: 16px;
            margin-bottom: 4px;
          }

          h5 {
            margin: 0px;
            font-size: 13px;
            color: #646262;
            margin-bottom: 10px;
          }

          p {
            margin: 0px;
            font-size: 11px;
            margin-bottom: 10px;
            color: #646262;
          }

          p.comment {
            font-size: 11px;
            text-align: justify;
          }

          .menu {
            position: absolute;
            top: 20px;
            right: 10px;
          }

          .tags {
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            margin-bottom: 10px;
            width: 100%;

            .tag {
              padding: 5px 10px;
              background: rgb(150, 150, 150);
              color: #fff;
              display: flex;
              align-items: center;
              margin-bottom: 8px;
              margin-right: 8px;
              font-size: 11px;
              border-radius: 5px;

              .remove-btn {
                font-size: 14px;
                color: #fff;
              }
            }
          }
        }

        .widget-container {
          background: #ffffff;
          padding: 10px 10px;
          margin-bottom: 20px;
          border-radius: 5px;

          .container-header {
            display: flex;
            justify-content: space-between;
            padding: 15px 0px;

            h3 {
              font-size: 14px;
              margin: 0px;
            }

            .btn-view-all {
              color: #0884af;
            }
          }

          .widget-body {
            .card {
              width: 100%;
              background: #f5f5f5;
              position: relative;
              padding: 8px 8px;
              border-radius: 5px;
              margin-bottom: 5px;

              .card-header {
                display: flex;
                justify-content: space-between;
                margin-bottom: 5px;
                width: 100%;

                .title {
                  font-size: 14px;

                  color: #000;
                  overflow: hidden;
                  text-decoration: none;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  width: 99%;
                }

                .card-type {
                  display: flex;
                  align-items: center;
                  justify-content: flex-end;

                  label {
                    font-size: 10px;
                    white-space: nowrap;
                    text-align: right;
                  }

                  .type-box {
                    height: 15px;
                    width: 15px;
                    border-radius: 2px;
                    margin-left: 5px;
                  }
                }
              }

              .compang-widget {
                display: flex;
                flex-direction: column;
                padding-right: 20px;

                .company-name {
                  color: #707070;
                  font-size: 12px;
                  margin-bottom: 5px;
                }

                .company-contact {
                  display: flex;
                  align-items: center;
                  margin-bottom: 5px;

                  span {
                    font-size: 12px;
                    white-space: nowrap;
                  }

                  .other-contact {
                    color: #ccc;
                    font-size: 12px;
                    white-space: nowrap;
                  }
                }
              }

              .members {
                display: flex;

                .member {
                  display: flex;
                  align-items: center;

                  img {
                    width: 20px;
                    height: 20px;
                    object-fit: cover;
                    margin-right: 4px;
                    border-radius: 50%;
                    border: 2px solid #fff;

                    &.override {
                      margin-left: -10px;
                    }
                  }

                  .name {
                    background: #06a1a11f;
                    padding: 2px 5px;
                    border-radius: 15px;
                    font-size: 11px;
                    color: #04a5a5;
                    display: block;
                  }
                }
              }

              .due-date {
                position: absolute;
                bottom: 18px;
                right: 15px;
                font-size: 10px;
                display: none;
              }

              &.hold {
                border: solid#04a5a5 1px;
                border-radius: 5px;
              }

              &.invisible {
                opacity: 0.5;
              }
            }

            .lead-card {
              width: 100%;
              background: #f5f5f5;
              position: relative;
              padding: 15px 15px;
              cursor: pointer;
              border-radius: 5px;
              margin-bottom: 5px;

              &:hover {
                .card-header {
                  .card-checkbox {
                    display: block;
                  }
                }
              }

              .card-header {
                display: flex;
                justify-content: flex-end;
                position: absolute;
                right: 2px;
                top: 8px;

                .card-checkbox:checked {
                  display: block;
                }

                .card-checkbox {
                  display: none;
                }
              }

              .title-widget {
                margin-bottom: 5px;

                .lead-name {
                  font-size: 14px;

                  color: #000;
                  overflow: hidden;
                  text-decoration: none;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  width: 115px;
                }
              }

              .compang-widget {
                display: flex;
                justify-content: space-between;
                padding-right: 20px;

                .company-name {
                  color: #0884af;
                  font-size: 12px;
                }

                .company-contact {
                  display: flex;
                  align-items: center;
                  margin-bottom: 5px;

                  span {
                    font-size: 12px;
                    white-space: nowrap;
                  }

                  .other-contact {
                    color: #ccc;
                    font-size: 12px;
                    white-space: nowrap;
                  }
                }
              }

              .members {
                margin-top: 5px;
                display: flex;

                .member {
                  display: flex;
                  align-items: center;

                  img {
                    width: 20px;
                    height: 20px;
                    object-fit: cover;
                    margin-right: 4px;
                    border-radius: 50%;
                    border: 2px solid #fff;

                    &.override {
                      margin-left: -10px;
                    }
                  }

                  .name {
                    background: #06a1a11f;
                    padding: 2px 5px;
                    border-radius: 15px;
                    font-size: 11px;
                    color: #04a5a5;
                    display: block;
                  }
                }
              }

              .price {
                color: rgb(134, 134, 134);
                position: absolute;
                bottom: 18px;
                right: 15px;
                font-size: 10px;
              }

              .attachment {
                width: 100%;
                padding: 0px 10px;

                img {
                  width: 100%;
                  height: 70px;
                  object-fit: cover;
                  border-radius: 20px;
                }
              }
            }
          }
        }

        .footer {
          display: none;
          justify-content: center;
          padding: 30px;

          @media (min-width: 300px) and (max-width: 630px) {
            display: flex;
          }

          .btn-cancel {
            background: #24a5a5;
            height: 50px;
            width: 125px;
            color: #fff;
            outline: none;
            border: none;
            border-radius: 5px;
            margin-right: 15px;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }
      }
    }
  }
}

.page-wrapper {
  .page-body {
    .page-body-container {
      .contacts-table {
        .table-row {
          &.opted_out {
            opacity: 0.5;
          }

          .opt_blur {
            &.active {
              opacity: 1;
            }
          }
        }

        .opted-out {
          background: #ff000021;
          padding: 2px 8px;
          border-radius: 3px;
          color: #ff0000;
          font-size: 11px;
          white-space: nowrap;
        }

        .checkbox {
          width: 15px;
          height: 15px;
          margin-right: 10px;
        }

        .space-between {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .row {
          display: flex;
          align-items: center;
        }

        .h-spacer {
          width: 10px;
        }

        .email {
          font-size: 12px;
          margin-bottom: 3px;
        }

        .phone {
          font-size: 12px;
          color: #666;
        }

        .contact-account {
          cursor: pointer;

          &:hover {
            opacity: 0.8;
          }
        }
      }
    }
  }
}

.slide-enter-active,
.slide-leave-active,
.slide-enter-from,
.slide-leave-to,
.slide-enter-to,
.slide-leave-from {
  display: none;
}

.dropdown-item {
  min-width: 100px;

  &.active {
    background-color: #1BA5A4;
    color: white;
    font-weight: 500;
    position: relative;

    &::after {
      content: '✓';
      position: absolute;
      right: 10px;
    }
  }

  &:hover {
    background-color: #f5f5f5;

    &.active {
      background-color: #1BA5A4;
    }
  }
}
</style>
